import { getLogs } from "@/api/logs";
import Vue from "vue";

const state = {
  items: [],
  total: 0,
  page: 1,
  pageSize: 50,
  pages: 0,
};

const mutations = {
  SET_LOGS(state, { items, total, page, page_size, pages }) {
    state.items = items;
    state.total = total;
    state.page = page;
    state.pageSize = page_size;
    state.pages = pages;
  },
};

const actions = {
  async fetchLogs({ commit }, { page = 1, pageSize = 50, filters = {} } = {}) {
    try {
      const data = await getLogs({ page, page_size: pageSize, ...filters });
      commit("SET_LOGS", data);
    } catch (e) {
      Vue.$toast.error(e, { duration: 0 });
    }
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
